import React, { useState } from "react";
import style from "./tooltip.module.scss";

const Tooltip = ({ text, position = "Top", children }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div
      className={style.tooltipContainer}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && <div className={style.tooltipBox}>{text}</div>}
    </div>
  );
};

export default Tooltip;
